import ArtworkPlaceholderCode from "./ArtworkPlaceholderCode"

export default ArtworkPlaceholderCode